const PREFIX = 'LEADS_SATISFACTION';
// eslint-disable-next-line import-x/prefer-default-export
export const LIST_LEADS_SATISFACTION = `${PREFIX}/LIST`;
